import React from 'react'
import {
    Toolbar,
} from '@mui/material'

import Home from './../../components/home/home.js'
import About from './../../components/about/about.js'
import Skills from './../../components/skills/skills.js'

const Main = () =>
    <React.Fragment>
        <div id='Home'></div>
        <Home />

        <div id='About'></div>
        <Toolbar />
        <About />

        <div id='Skills'></div>
        <Toolbar />
        <Toolbar />
        <Skills />

        <Toolbar />
    </React.Fragment>

export default Main